import React from 'react';
import {
  HiOutlineLocationMarker,
  HiOutlineTruck,
  HiOutlineSparkles,
  HiOutlineFire,
  HiOutlineSun,
  HiOutlineGlobeAlt,
  HiOutlineUserGroup,
} from 'react-icons/hi';
import './OurServices.css';

const services = [
  {
    icon: HiOutlineLocationMarker,
    title: 'Guided journeys',
    text:
      'Quiet, expert local guides who reveal viewpoints, stories, and trails most never find.',
  },
  {
    icon: HiOutlineTruck,
    title: 'Hill transport',
    text:
      'Comfortable transfers from Bandarban town to Damtua and the surrounding villages.',
  },
  {
    icon: HiOutlineSparkles,
    title: 'Inn restaurant',
    text:
      'Regional dishes — tribal and Bengali — cooked in our open kitchen with the breeze.',
  },
  {
    icon: HiOutlineFire,
    title: 'Bonfire & BBQ',
    text:
      'Slow evenings with bonfire, tribal grill, and a music programme under open sky.',
  },
  {
    icon: HiOutlineSun,
    title: 'Walks & waterfalls',
    text:
      'Gentle walks to Damtua’s waterfalls and forest trails for a long, mindful pause.',
  },
  {
    icon: HiOutlineGlobeAlt,
    title: 'Culture & heritage',
    text:
      'Conversations with our indigenous neighbours — a window into a living tradition.',
  },
  {
    icon: HiOutlineUserGroup,
    title: 'Community pavilion',
    text:
      'A graceful gathering space for weddings, birthdays, and meaningful events.',
  },
];

const Services = () => {
  return (
    <section className="services-section">
      <div className="services-container">
        <header className="services-head">
          <span className="eyebrow center">In-House</span>
          <h2>Services & studio</h2>
          <p className="services-intro">
            Everything we offer is built around one belief — that a stay should feel
            unhurried, considered, and quietly memorable.
          </p>
        </header>

        <div className="services-grid">
          {services.map(({ icon: Icon, title, text }) => (
            <article className="service-card" key={title}>
              <Icon className="service-icon" aria-hidden="true" />
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
